import React from "react";
import BrandContainer from "./styles/Brand.style";
import Brand1 from "images/logo-72andsunny.svg";
import Brand2 from "images/logo-facebook.svg";
import Brand3 from "images/logo-droga5.svg";
import Brand4 from "images/logo-google.svg";
import Brand5 from "images/logo-rga.svg";
import Brand6 from "images/logo-nike.svg";
import Brand7 from "images/logo-pg.svg";
import Brand8 from "images/logo-ogilvy.svg";
import Brand9 from "images/logo-fiat.svg";
import Brand10 from "images/logo-deutsch.svg";
import Brand11 from "images/logo-santander.svg";
import Brand12 from "images/logo-aetna.svg";

function Brand() {
  const brandImagesDesktop = [
    Brand1,
    Brand2,
    Brand3,
    Brand4,
    Brand5,
    Brand6,
    Brand7,
    Brand8,
    Brand9,
    Brand10,
    Brand11,
    Brand12
  ];

  const brandImagesMobile = [
    Brand1,
    Brand4,
    Brand5,
    Brand2,
    Brand6,
    Brand9,
    Brand7,
    Brand11,
    Brand3
  ];

  return (
    <BrandContainer>
      <div className="brand-wrapper">
        <h1 className="brand-title">Empowering Creators, One Frame at a Time</h1>
        <p className="brand-description">
          We're a global leader in user-generated video content, with a vast library and bespoke
          services. Our trusted content powers brands worldwide and fuels our own successful
          streaming channels.
        </p>
      </div>

      <div className="brands-container-desktop">
        {brandImagesDesktop.map((brand, index) => (
          <img key={index} src={brand} alt={`brand-logo-${index + 1}`} />
        ))}
      </div>

      <div className="brands-container-mobile">
        {brandImagesMobile.map((brand, index) => (
          <img
            key={index}
            src={brand}
            className={`brand-logo-mobile-${index + 1}`}
            alt={`brand-logo-${index + 1}`}
          />
        ))}
      </div>
    </BrandContainer>
  );
}

export default Brand;
